var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appPage",class:{isMain: _vm.isMain, isMobile: _vm.isMobile, isMobileTop: _vm.isMobileTop, isFans: _vm.isFans},attrs:{"id":"app"}},[_c('div',{staticClass:"web"},[_c('WebView')],1),_c('div',{staticClass:"mobile"},[_c('Header'),_c('router-view'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }